import appConfig from '@/constants/appConfig'
import errorCodes from '@/constants/errorCodes'
import { getAuthHeaders } from '@/helpers/apiHelper'
import AppService from '@/services/appService'

class AiApiClient {
  private readonly baseUrl: string
  private appService

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
    this.appService = new AppService()
  }

  async fetchWithRetry(
    url: string,
    options: RequestInit,
    isContentTypeNotRequired = false,
    retryCount = 1,
    fromautofix = false
  ): Promise<any> {
    const response = await fetch(this.baseUrl + url, options)
    if (response.status === 204 && fromautofix == true) {
      return {
        status: 204,
        message: "No products present. Autofix not possible."
      };
    }
    if (response.status === 422 && fromautofix == true) {
      return {
        status: 500,
        message: response.statusText
      };
    }
    const responseData = await response.json()

    if ((response.status === 401 || response.status === 403) && retryCount > 0) {
      if (responseData.detail.errorCode == errorCodes.TokenExpiredException) {
        await this.regenerateToken()

        options.headers = getAuthHeaders(isContentTypeNotRequired)
        return this.fetchWithRetry(url, options, isContentTypeNotRequired, retryCount - 1)
      } else if (
        responseData.detail.errorCode == errorCodes.TokenInvalidException ||
        responseData.detail.errorCode == errorCodes.TokenMalformedException
      ) {
        this.appService.clearAuthData(false)
      }
    }

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return responseData
  }
  async fetchApi(url: string,
    options: RequestInit,
    isContentTypeNotRequired = false,
    retryCount = 1,): Promise<any> {
    await this.regenerateToken()

    options.headers = getAuthHeaders(isContentTypeNotRequired)
    return this.fetchWithRetry(url, options, isContentTypeNotRequired, retryCount - 1)
  }
  private async regenerateToken() {
    const response = await this.regenerateTokenPairs()

    const responseData = await response.json()

    if (response.status == 401 && (responseData.errorCode == errorCodes.RefreshTokenExpired || responseData.errorCode == errorCodes.TokenInvalidException)) {
      await this.appService.clearAuthData()
    } else {
      localStorage.setItem('accessToken', responseData.data.accessToken)
    }
  }

  private async regenerateTokenPairs() {
    const payload = {
      portal: import.meta.env.DEV ? 'be.stunnr.co' : window.location.hostname,
      clientId: appConfig.STUNNR_BE_CLIENT_ID,
      grantType: 'refresh_token',
    }

    const response = await fetch(window.location.origin + '/api/oauth2/token', {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    })

    return response
  }
}

export default AiApiClient
